"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormGroup.default;
  }
});

var _FormGroup = _interopRequireDefault(require("./FormGroup"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/FormGroup/index.js
 ** module id = 310
 ** module chunks = 0
 **/